import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserInfo } from 'Utils';
import * as analytics from 'Utils/analytics';
import {
  deleteInterest,
  getInterests,
  saveInterest,
  setOptout,
} from 'Services/interests';
import interests from 'Services/interests/interests.json';
import InterestsSelectorNew from 'Components/profile/InterestsSelectorNew';
const { EVENTS } = analytics;

const Interests = ({ strings, uim }) => {
  const [hasInterests, setHasInterests] = useState(false);
  const [selections, setSelections] = useState([]);
  const [userInterests, setUserInterests] = useState([]);

  const interestsArray = interests && Object.keys(interests);

  const deselectInterest = async (item) => {
    analytics.event({ action: EVENTS.deselectInterestItem, label: item });

    const { userToken, userId } = await getUserInfo(uim);
    deleteInterest(item, userId, userToken);

    const items = selections.filter((selections) => selections !== item);
    setSelections(items);

    if (selections.length === 0) {
      setOptout(true, userId, userToken);
    }
  };

  const selectInterest = async (item) => {
    analytics.event({ action: EVENTS.selectInterestItem, label: item });

    const { userToken, userId } = await getUserInfo(uim);
    saveInterest(item, userId, userToken);

    const items = [...selections, item];
    setSelections(items);
  };

  const onChange = (event) => {
    if (event.target.checked) {
      selectInterest(event.target.value);
    } else {
      deselectInterest(event.target.value);
    }
  };

  const formatInterests = async () => {
    const { userToken, userId } = await getUserInfo(uim);
    const userInterests = await getInterests(userId, userToken);
    if (userInterests?.length) {
      setHasInterests(true);
      setSelections(userInterests);
      setUserInterests(userInterests);
    } else {
      setUserInterests(userInterests);
    }
  };

  useEffect(() => {
    formatInterests();
  }, []);

  return (
    <div>
      <div className="sidebar-view__header desktop__header">
        <h1 className="sidebar-view__heading">{strings.interests}</h1>
      </div>
      <div className="sidebar-view__inner">
        <div className="row__label">{strings.interestsHeading2}</div>
        <InterestsSelectorNew
          hasInterests={hasInterests}
          interests={interests}
          interestsArray={interestsArray}
          onChange={onChange}
          selections={selections}
          userInterests={userInterests}
        />
        <div className="row__label">
          {strings.interestsRecommendationsHeading}
        </div>
        <div className="row__content">
          {strings.interestsRecommendationsEmpty}
        </div>
      </div>
    </div>
  );
};

Interests.propTypes = {
  applicationConfig: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
};

Interests.defaultProps = {};

export default Interests;
